import React, { useEffect, useMemo, useState } from "react";
import { flattenCategories } from "../../utils/flattenCategories";
import { useEventCategory } from "./hooks/useEventCategory";
import { getImageUrl } from "utils/imageHelper";
import ImageViewer from "components/common/ImageViewer";
import { InputField, SelectField, ImageUploadField } from ".././FormFields";
import { validateImageFile } from "utils/common";

export default function EventCategoryForm({ initialData, onSubmit }) {
  const { categories, loadCategoriesByOrganizer } = useEventCategory();
  const companyId = localStorage.getItem("company_id");

  const [form, setForm] = useState({
    title: "",
    parent_id: "",
    eventCategoryImage: null,
  });

  const [viewerOpen, setViewerOpen] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (companyId) {
      loadCategoriesByOrganizer(companyId);
    }
  }, [companyId]);

  useEffect(() => {
    if (initialData) {
      setForm({
        title: initialData.title || "",
        parent_id: initialData.parent_id?._id || initialData.parent_id || "",
        eventCategoryImage: initialData.eventCategoryImage || null,
      });
    }
  }, [initialData]);

  const parentCategories = useMemo(
    () => flattenCategories(categories || []),
    [categories]
  );

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const { isValid, error } = await validateImageFile(file, 1);

    if (!isValid) {
      setErrors((prev) => ({ ...prev, image: error }));
      return; // Stop execution if validation fails
    }

    // 2. Clear error and update state if valid
    setErrors((prev) => ({ ...prev, image: "" }));
    setForm((prev) => ({
      ...prev,
      eventCategoryImage: file,
    }));
  };

  const submit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", form.title);
    formData.append("company_id", companyId);
    if (form.parent_id) formData.append("parent_id", form.parent_id);
    if (form.eventCategoryImage)
      formData.append("eventCategoryImage", form.eventCategoryImage);

    await onSubmit(formData);
  };

  if (!companyId) {
    return <p className="p-4 text-red-500">Please select a company first.</p>;
  }

  return (
    <form onSubmit={submit} className="flex flex-col gap-3">
      <SelectField
        label="Parent Category"
        name="parent_id"
        value={form.parent_id || ""}
        onChange={(e) => setForm({ ...form, parent_id: e.target.value })}
        options={(parentCategories || []).map((item) => ({
          value: item._id,
          label: item.title,
        }))}
        placeholder="Search category..."
        isSearchable={true}
      />
      {/* 
      <div>
        <label className="mb-1 block text-sm font-medium">
          Parent Category
        </label>
        <select
          className="w-full rounded border p-2"
          value={form.parent_id}
          onChange={(e) =>
            setForm({ ...form, parent_id: e.target.value })
          }
        >
          <option value="">Parent Category (Optional)</option>
          {parentCategories.map((cat) => (
            <option key={cat._id} value={cat._id}>
              {cat.title}
            </option>
          ))}
        </select>
      </div> */}
      <InputField
        label="Category Title"
        name="title"
        value={form.title}
        onChange={(e) => setForm({ ...form, title: e.target.value })}
        required
        placeholder="Enter category title"
      />

      {/* <div>
        <label className="mb-1 block text-sm font-medium">
          Category Title<span className="text-red-500">*</span>
        </label>
        <input
          className="w-full rounded border p-2"
          placeholder="Category Title"
          value={form.title}
          onChange={(e) => setForm({ ...form, title: e.target.value })}
          required
        />
      </div> */}
      <ImageUploadField
        label="Image"
        name="eventCategoryImage"
        recommended={
          <>
            Recommended resolution: 393 × 219 px. Accepted formats: JPEG, PNG.
          </>
        }
        preview={
          form.eventCategoryImage && typeof form.eventCategoryImage === "string"
            ? getImageUrl(form.eventCategoryImage)
           : form.eventCategoryImage ?URL.createObjectURL(form.eventCategoryImage):""
        }
        onUpload={handleFileChange}
        required
        error={errors.image}
      />
      {/* <div>
        <label className="mb-1 block text-sm font-medium">
          Image <span className="text-gray-400">(Optional)</span>
          <span className="ml-2 text-xs font-normal text-gray-500">
            (Recommended resolution: 393 × 219 px. Accepted formats: JPEG, PNG.
            )
          </span>
        </label>

        <input
          type="file"
          accept="image/png, image/jpeg"
          onChange={handleFileChange}
          className="w-full rounded border p-2 file:mr-3 file:rounded file:border-0 file:bg-gray-100 file:px-3 file:py-1"
        />

        {form.eventCategoryImage &&
          typeof form.eventCategoryImage === "string" && (
            <>
              <img
                src={getImageUrl(form.eventCategoryImage)}
                alt="Category"
                className="mt-2 h-24 cursor-pointer rounded border object-contain"
                onClick={() => setViewerOpen(true)}
              />
              <ImageViewer
                open={viewerOpen}
                onClose={() => setViewerOpen(false)}
                src={getImageUrl(form.eventCategoryImage)}
              />
            </>
          )}
      </div> */}
      <div className="mt-4 flex justify-end">
        <button className="btn-primary">
          {initialData ? "Update" : "Save"}
        </button>
      </div>
    </form>
  );
}
